import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Placeholder from 'flarum/common/components/Placeholder';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionSkeleton from './DiscussionSkeleton';
import HomeDiscussionsState from '../states/HomeDiscussionsState';
//import DiscussionListState from 'flarum/states/DiscussionListState';
import LinkButton from 'flarum/common/components/LinkButton';
import { slug } from '../../common';

//Add Siderbar
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import type Mithril from 'mithril';

//import Dropdown from 'flarum/common/components/Dropdown';
//import Button from 'flarum/common/components/Button';
//import LinkButton from 'flarum/common/components/LinkButton';
//import SelectDropdown from 'flarum/common/components/SelectDropdown';
//import extractText from 'flarum/common/utils/extractText';
//import DiscussionComposer from 'flarum/DiscussionComposer';


//import type Discussion from 'flarum/common/models/Discussion';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.home.discussions`;

export default class HomeDiscussions_Laster extends Component {
	oninit(vnode) {
		super.oninit(vnode);

		/**
		 * The discussion list state.
		 *
		 * @type {HomeDiscussionsState}
		 */
		//this.discussions = new DiscussionListState(
		this.discussions = new HomeDiscussionsState(
			this.defaultParams,
			1,
			this.limit,
			this.preloadedKey,
		);

		this.discussions.refresh();
	}

	get preloadedKey() {
		return this.attrs.preloadedKey ? this.attrs.preloadedKey : 'discussions';
	}

	get defaultParams() {
		const { params } = this.attrs;
		const defaultParams = { include: [], filter: {} };
		return {
			...defaultParams,
			...params,
		};
	}

	// for child classes
	getDefaultParams() {
		return this.defaultParams;
	}

	get limit() {
		return 6;
	}

	get baseClass() {
		return 'HomeDiscussions';
	}

	view() {
		return (
			<>
			<div className={`${this.baseClass} container`}>
				<h2 class={`title-disc`}>
					<span>{this.titleText}</span>
				</h2>

                <span className={`discussions_button`}>
					{this.button}
					<nav className={`HomePage-nav sideNav`}><ul>{listItems(this.sidebarItems().toArray())}</ul></nav>
					{this.button_all}
				</span>

				{/* Show skeleton elements when loading */}
				{this.discussions.isInitialLoading() && (
					<ul className={`${this.baseClass}-discussions`}>
						{Array.from(Array(this.limit).keys()).map(this.skeletonItem)}
					</ul>
				)}

				{this.discussions.isEmpty() && <Placeholder text={this.emptyText} />}

				{this.discussions.hasItems() && (
					<ul className={`${this.baseClass}-discussions`}>
						{this.discussions.getAllItems().map(this.listItem)}
					</ul>
				)}
			</div>
			</>
		);
	}

	get button() {
		const { showBtn } = this.attrs;
		if (!showBtn) {
			return null;
		}

		const allowed = app.forum.attribute('canStartDiscussion') || !app.session.user;

		const prfx = 'core.forum.index';
		const label = t(
			allowed ? `${prfx}.start_discussion_button` : `${prfx}.cannot_start_discussion_button`,
		);

		return (
			<Button
				className='Button Button--large IndexPage-newDiscussion'
				icon="fas fa-edit"
				itemClassName='App-primaryControl'
				onclick={IndexPage.prototype.newDiscussionAction.bind(IndexPage.prototype)}
				disabled={!allowed}>
				{label}
			</Button>
		);
	}

	get button_all() {
		const { showallBtn } = this.attrs;
		if (!showallBtn) {
			return null;
		}

		return (
			<LinkButton href={this.allLinkHref} className='LinkButton'>
				{this.allLinkText}
			</LinkButton>
		);
	}

	get allLinkText() {
		return t(`${prfx}.all_link`);
	}

	get allLinkHref() {
		return app.route('index');
	}

	get titleText() {
		const { title } = this.attrs;
		return title;
	}

	get emptyText() {
		return t('core.forum.discussion_list.empty_text');
	}

	listItem(discussion) {
		return (
			<li key={discussion.id()} data-id={discussion.id()}>
				<DiscussionListItem discussion={discussion} params={{}} />
			</li>
		);
	}

	skeletonItem() {
		return <DiscussionSkeleton />;
	}

	//ADD SIDEBAR
	/**
   * Build an item list for the sidebar of the index page. By default this is a
   * "New Discussion" button, and then a DropdownSelect component containing a
   * list of navigation items.
   */
	sidebarItems() {
		const items = new ItemList<Mithril.Children>();
		/*const canStartDiscussion = app.forum.attribute('canStartDiscussion') || !app.session.user;
	
		items.add(
		  'newDiscussion',
		  <Button
			icon="fas fa-edit"
			className="Button Button--primary IndexPage-newDiscussion"
			itemClassName="App-primaryControl"
			onclick={() => {
			  // If the user is not logged in, the promise rejects, and a login modal shows up.
			  // Since that's already handled, we dont need to show an error message in the console.
			  return this.newDiscussionAction().catch(() => {});
			}}
			disabled={!canStartDiscussion}
		  >
			{app.translator.trans(`core.forum.index.${canStartDiscussion ? 'start_discussion_button' : 'cannot_start_discussion_button'}`)}
		  </Button>
		);*/
	
		/*items.add(
		  'nav',
		  <SelectDropdown
			buttonClassName="Button"
			className="App-titleControl"
			accessibleToggleLabel={app.translator.trans('core.forum.index.toggle_sidenav_dropdown_accessible_label')}
		  >
			{this.navItems().toArray()}
		  </SelectDropdown>
		);*/
	
		return items;
	}
	
	  /**
	   * Build an item list for the navigation in the sidebar of the index page. By
	   * default this is just the 'All Discussions' link.
	   */
	/*navItems() {
		const items = new ItemList<Mithril.Children>();
		const params = app.search.stickyParams();
	
		items.add(
		  'allDiscussions',
		  <LinkButton href={app.route('index', params)} icon="far fa-comments">
			{app.translator.trans('core.forum.index.all_discussions_link')}
		  </LinkButton>,
		  100
		);
	
		return items;
	}*/
	/**
   * Open the composer for a new discussion or prompt the user to login.
   */
	/*newDiscussionAction(): Promise<unknown> {
		return new Promise((resolve, reject) => {
		  if (app.session.user) {
			app.composer.load(DiscussionComposer, { user: app.session.user });
			app.composer.show();
	
			return resolve(app.composer);
		  } else {
			app.modal.show(LogInModal);
	
			return reject();
		  }
		});
	}*/
}